import {NotificationTypeEnum, Page, TableParamsType} from '../common';
import {UserDTO} from '../users';
import {BaseBusinessInfo, LocationDTO} from '../locations';

export interface NotificationsRequest {
    businessId: number;
    createdFrom?: number;
    createdTo?: number;
    /**
     * Narrows to particular kinds, when somebody asks for that.
     *
     * Optional because nothing derives it any more: it was filled from the account type, so a manager
     * never saw the kinds their type was not listed for, and a message nobody is told about is a
     * message lost. Who may read notifications at all is what notifications.search answers.
     */
    notificationTypes?: NotificationTypeEnum[];
    read?: boolean;
    /** Part of a word, any case: the message, the sender's name, email or company, the location's name. */
    keyword?: string;
    sortAsc?: boolean;
    sortField?: NotificationsSortEnum;
    userId?: number;
}

export enum NotificationsSortEnum {
    CREATED = 'CREATED',
    TYPE = 'TYPE',
}

export interface NotificationsSearchRequest {
    params: TableParamsType;
    data: NotificationsRequest;
}

export interface NotificationByIdRequest {
    notificationId: number;
    data: {
        businessId: number;
        notificationType: NotificationTypeEnum;
    };
}

export interface NotificationMarkAsReadRequest {
    notificationId: number;
    data: {
        businessId: number;
        notificationType: NotificationTypeEnum;
    };
}

export interface NotificationMarkAsUnreadRequest {
    notificationId: number;
    data: {
        businessId: number;
        notificationType: NotificationTypeEnum;
    };
}

export interface NotificationDTO {
    /**
     * The business the notification belongs to, as an object - the server sends `business`, never a
     * `businessId`. A `businessId: number` used to be declared here and was always undefined at
     * runtime, which is how NotificationCard came to send nothing where the API requires a value.
     */
    business?: BaseBusinessInfo;
    created: number;
    read: boolean;
    id: number;
    message: string;
    type: NotificationTypeEnum;
    location: LocationDTO;
    user: UserDTO;
    readAt: number;
    readByManager: ManagerType;
}

export interface ManagerType {
    emailAddress: string;
    firstName: string;
    id: 0;
    lastName: string;
}

export interface NotificationsPageDTO extends Page {
    content: NotificationDTO[];
}
